import UpdateInboxLocation from './lib/update_inbox_location';

export default class SetInboxScrollPosition extends UpdateInboxLocation {
  updateInbox(inbox, scrollPosition) {
    inbox.setTransientState({ scrollPosition });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/inbox/set_inbox_scroll_position.js